import type { IUser } from "./types";

const SF_CONFIG = {
  orgId: "00D41000000GNzs",
  name: "GoGuardian_Offline_Support",
  baseUrl:
    "https://goguardian.my.site.com/ESWGoGuardianOfflineSup1770722407612",
  scrt2URL: "https://goguardian.my.salesforce-scrt.com",
  scriptUrl:
    "https://goguardian.my.site.com/ESWGoGuardianOfflineSup1770722407612/assets/js/bootstrap.min.js",
};

interface PrechatFieldDef {
  value: string;
  isEditableByEndUser: boolean;
}

type VisiblePrechatFields = Record<string, PrechatFieldDef>;

//Salesforce Embedded Messaging prechat API (bootstrap script).
interface EmbeddedServicePrechatAPI {
  setVisiblePrechatFields?: (fields: VisiblePrechatFields) => void;
  setHiddenPrechatFields?: (fields: Record<string, { value: string }>) => void;
}

//Bootstrap global injected by Salesforce Embedded Messaging script.
interface EmbeddedServiceBootstrap {
  prechatAPI?: EmbeddedServicePrechatAPI;
  settings?: { language?: string };
  init: (
    orgId: string,
    embeddedServiceName: string,
    baseUrl: string,
    options: { scrt2URL: string }
  ) => void;
}

declare global {
  interface Window {
    embeddedservice_bootstrap?: EmbeddedServiceBootstrap;
  }
}

export function removeChatbox(): void {
  const chatbox = document.getElementById("embedded-messaging");
  if (chatbox) {
    chatbox.remove();
  }
}

// Standard Salesforce pre-chat field names (with underscore). See:
// https://developer.salesforce.com/docs/service/messaging-web/guide/populate-prechat-fields.html
function buildVisiblePrechatFields(
  user: IUser | null | undefined
): VisiblePrechatFields {
  return {
    Product: {
      value: "Giant Steps",
      isEditableByEndUser: false,
    },
    _firstName: {
      value: user?.given_name ?? "",
      isEditableByEndUser: true,
    },
    _lastName: {
      value: user?.family_name ?? "",
      isEditableByEndUser: true,
    },
    _email: {
      value: user?.email ?? "",
      isEditableByEndUser: true,
    },
  };
}

function applyPrechatFields(user: IUser | null | undefined): void {
  const api = window.embeddedservice_bootstrap?.prechatAPI;
  if (api?.setVisiblePrechatFields) {
    api.setVisiblePrechatFields(buildVisiblePrechatFields(user));
  }
  if (api?.setHiddenPrechatFields) {
    api.setHiddenPrechatFields({ site_Url: { value: window.location.origin } });
  }
}

function initStylesAndConfig(user: IUser | null | undefined): void {
  try {
    const bootstrap = window.embeddedservice_bootstrap;
    if (!bootstrap) return;
    if (bootstrap.settings) bootstrap.settings.language = "en_US";

    window.addEventListener("onEmbeddedMessagingReady", () => {
      applyPrechatFields(user);
    });

    bootstrap.init(SF_CONFIG.orgId, SF_CONFIG.name, SF_CONFIG.baseUrl, {
      scrt2URL: SF_CONFIG.scrt2URL,
    });
  } catch (err) {
    console.error("Error loading Embedded Messaging: ", err);
  }
}

export function initSFChat(user: IUser | null | undefined): void {
  if (!window.embeddedservice_bootstrap) {
    const s = document.createElement("script");
    s.src = SF_CONFIG.scriptUrl;
    s.onload = () => {
      initStylesAndConfig(user);
    };
    document.body.appendChild(s);
  }
}
